module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"opacity":"Opacité","time":"Sélection temporelle","legend-label":"Légende","opacity-label":"Opacité","delete-label":"Supprimer","layer-list-label":"Liste des couches"},"de":{}}')
  delete Component.options._Ctor
}
